<template>
    <div class="searchItemTitle">{{ $t('Дата публикации') }}</div>
    <v-container fluid class="pa-0">
        <v-row>
            <v-col cols="6">
                <DatePicker
                    :placeholder="$t('С')"
                    type="date"
                    v-model:value="searchParams.applicationDeadline.dates[0]"
                    :lang="lang"
                />
            </v-col>
            <v-col cols="6">
                <DatePicker
                    :placeholder="$t('По')"
                    type="date"
                    v-model:value="searchParams.applicationDeadline.dates[1]"
                    :lang="lang"
                />
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import DatePicker from 'vue-datepicker-next';
import Config from '@/config';

export default {
    name: 'ApplicationDeadline',
    components: {
        DatePicker
    },
    props: {
        searchParams: {
            type: Object,
            required: true,
            default() {
                return {
                    applicationDeadline: {
                        dates: []
                    }
                }
            }
        },
    },
    data() {
      return {
        lang: Config.getUser().getLang()
      }
    }
}
</script>
<style scoped>
:deep(.mx-datepicker-range) {
    width: 100%;
}
:deep(.mx-input) {
    height: 40px !important;
    font-family: var(--primary-font-family-name);
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    border-radius: 6px !important;
    border: 1px solid rgb(var(--grey-border-color)) !important;
    background: #FFF;
    box-shadow: none;
    padding: 0 30px 6px 10px;
}

:deep(.mx-input::placeholder) {
    font-family: var(--primary-font-family-name);
    font-size: 12px;
    color: rgba(var(--black-color), 0.4);
}

:deep(.mx-input:hover, .mx-input:focus) {
    border-color: rgba(var(--grey-1));
}

:deep(.mx-datepicker) {
  display: block;
  width: 100%;
}
</style>
